type Action = {
  type: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any
}

export const initialResponse = { response: null, error: null, loading: true }

const INIT = 'INIT'
const SUCCESS = 'SUCCESS'
const FAIL = 'FAIL'
const NOT_CALLED = 'NOT_CALLED'

export function responseReducer(state = initialResponse, action: Action) {
  switch (action.type) {
    case INIT:
      return { ...state, loading: true }
    case SUCCESS:
      return { response: action.payload, error: null, loading: false }
    case FAIL:
      return { response: null, error: action.payload, loading: false }
    case NOT_CALLED:
      return { response: null, error: null, loading: false }
    default:
      return state
  }
}

export const actionTypes = { INIT, SUCCESS, FAIL, NOT_CALLED }
